import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 xl:grid-cols-4 gap-4 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Kpi = _resolveComponent("Kpi")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpis, (kpi) => {
      return (_openBlock(), _createBlock(_component_Kpi, {
        key: kpi.index_id,
        kpi: kpi
      }, null, 8, ["kpi"]))
    }), 128))
  ]))
}